/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import { SnackbarsState, SnackbarsTypes } from './types';

const INITIAL_STATE: SnackbarsState = {
  snackbar: {
    open: false,
    message: '',
    type: undefined,
  },
  secondSnackbar: {
    open: false,
    message: '',
    type: undefined,
  },
};

const reducer: Reducer<SnackbarsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SnackbarsTypes.SET_OPEN:
      const { message, type, status } = action.payload;
      return {
        ...state,
        snackbar: { open: true, message, type, status },
      };
    case SnackbarsTypes.SET_CLOSE:
      return {
        ...state,
        snackbar: { open: false, message: '', type: state.snackbar.type },
      };
    case SnackbarsTypes.SET_SECOND_OPEN:
      return {
        ...state,
        secondSnackbar: {
          open: true,
          message: action.payload.message,
          type: action.payload.type,
          status: action.payload.status,
        },
      };
    case SnackbarsTypes.SET_SECOND_CLOSE:
      return {
        ...state,
        secondSnackbar: {
          open: false,
          message: '',
          type: state.secondSnackbar.type,
        },
      };
    default:
      return state;
  }
};

export default reducer;
